import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b8b0376&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DateYearPager: require('/home/runner/work/myody_front/myody_front/components/date/DateYearPager.vue').default,GoodsHistoryList: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsHistoryList.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
